import React, { useState } from "react";

import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
} from "reactstrap";

// Components
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import NotificationDropdown from "../Components/Common/NotificationDropdown";
import ProfileDropdown from "../Components/Common/ProfileDropdown";

import {
  changeSidebarVisibility,
} from "../slices/layouts/thunk";

import {
  useSelector,
  useDispatch,
} from "react-redux";

import { createSelector } from "reselect";


const Header = ({
  onChangeLayoutMode,
  layoutModeType,
  headerClass,
}) => {

  const dispatch = useDispatch();
  const selectDashboardData =
    createSelector(
      (state) => state.Layout,
      (sidebarVisibilitytype) =>
        sidebarVisibilitytype.sidebarVisibilitytype
    );
  const sidebarVisibilitytype =
    useSelector(
      selectDashboardData
    );
  const [
    search,
    setSearch,
  ] = useState(false);


  /* =========================================================
     SEARCH
  ========================================================= */

  const toogleSearch = () => {
    setSearch(
      (previous) => !previous
    );
  };


  /* =========================================================
     MOBILE SIDEBAR
  ========================================================= */

const toggleMobileSidebar = () => {
  document.body.classList.toggle("vertical-sidebar-enable");

  dispatch(
    changeSidebarVisibility(
      document.body.classList.contains("vertical-sidebar-enable")
        ? "show"
        : "hide"
    )
  );
};


  return (
    <React.Fragment>

      <header
        id="page-topbar"
        className={headerClass}
      >

        <div className="layout-width">

          <div className="navbar-header">


            {/* =================================================
                LEFT SIDE
            ================================================= */}

            <div className="d-flex align-items-center">

              {/* MOBILE MENU BUTTON */}

              <button
                onClick={
                  toggleMobileSidebar
                }
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
                aria-label="Toggle navigation"
              >

                <span className="hamburger-icon">

                  <span></span>
                  <span></span>
                  <span></span>

                </span>

              </button>

            </div>


            {/* =================================================
                RIGHT SIDE
            ================================================= */}

            <div className="d-flex align-items-center">


              {/* =================================================
                  MOBILE SEARCH
              ================================================= */}

              <Dropdown
                isOpen={search}
                toggle={
                  toogleSearch
                }
                className="d-md-none topbar-head-dropdown header-item"
              >

                <DropdownToggle
                  type="button"
                  tag="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >

                  <i className="bx bx-search fs-22"></i>

                </DropdownToggle>


                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">

                  <Form className="p-3">

                    <div className="form-group m-0">

                      <div className="input-group">

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          aria-label="Search"
                        />

                        <button
                          className="btn btn-primary"
                          type="submit"
                        >
                          <i className="mdi mdi-magnify"></i>
                        </button>

                      </div>

                    </div>

                  </Form>

                </DropdownMenu>

              </Dropdown>


              {/* =================================================
                  FULL SCREEN
              ================================================= */}

              <FullScreenDropdown />


              {/* =================================================
                  NOTIFICATIONS
              ================================================= */}

              <NotificationDropdown />


              {/* =================================================
                  PROFILE
              ================================================= */}

              <ProfileDropdown />

            </div>

          </div>

        </div>

      </header>

    </React.Fragment>
  );
};


export default Header;